import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import BrandSlideshow from '../components/BrandSlideshow'
import { motion } from 'framer-motion'
import sampleVideo from '../media/hero-video.mp4'
import teamImage from "../media/Creative Team.jpg";
import Apparel from "../media/Apparel.jpeg"
import Dynamic from '../media/Dynamic.avif'
import '../index.css'

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const fadeInLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};

export default function Home() {
  return (
    <div className="min-h-screen font-sans text-gray-800">
        <Header />
        <main>
            {/* HERO SECTION */}
            <motion.section
                className="relative w-full h-[500px] overflow-hidden"
                initial="hidden"
                whileInView="visible"
                variants={fadeInUp}
                viewport={{ once: true }}
              >
                {/* Background Video */}
                <video
                  className="absolute mt-16 md:mt-24 top-0 left-0 w-full h-full object-cover"
                  src={sampleVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                ></video>
    
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40"></div>
    
                {/* Hero Content */}
                <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-6">
                  <motion.h1
                    className="text-5xl md:text-7xl font-bold"
                    initial={{ opacity: 0, y: -30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                  >
                    Welcome to Yking
                  </motion.h1>
    
                  <motion.p
                    className="mt-4 text-lg md:text-2xl max-w-3xl"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.3 }}
                  >
                    Become The Leading Market Authority By Offering Innovative Fashion
                    Solutions With Transparency And Ethical Practices.
                  </motion.p>
                </div>
              </motion.section>

            {/* FEATURE BLOCK */}
            <motion.section
              className="bg-[#BF5717] text-white w-full py-16 my-0"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="max-w-7xl mx-8 flex flex-col md:flex-row items-center justify-between gap-12">
                
                {/* Text Section */}
                <motion.div
                  className="flex-1"
                  variants={fadeInLeft}
                >
                  <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                    Creative Team
                  </h2>
                  <p className="text-lg md:text-xl leading-relaxed">
                    Comprising manufacturers, designers, and IT specialists — collaborate 
                    to deliver innovative and cost-effective solutions to our clients.
                  </p>
                </motion.div>
      
                {/* Image Section */}
                <motion.div
                  className="flex-1 flex justify-center md:justify-end"
                  variants={fadeInRight}
                >
                  <img
                    src={teamImage}
                    alt="Creative Team"
                    className="rounded-2xl shadow-lg w-full object-cover"
                  />
                </motion.div>
      
              </div>
            </motion.section>
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center py-8 px-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {/* Image */}
            <motion.img
              src={Apparel}
              alt="shirts"
              className="w-full h-[400px] object-cover rounded-xl shadow-lg"
              variants={fadeInLeft}
              whileHover={{ scale: 1.03 }}
            />
      
            {/* Text Content */}
            <motion.div variants={fadeInRight}>
              <h4 className="text-2xl font-semibold mb-3 text-gray-900">
                Apparel that Transcends Design
              </h4>
              <p className="text-sm text-gray-800">
                We operate across various industries, including menswear, womenswear,
                kidswear, promotional wear, workwear, uniform, sportswear, home textile and shoes.
              </p>
              <motion.button
                className="mt-6 border px-4 py-2 text-sm shadow hover:bg-gray-900 hover:text-white transition-all duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth"
                })}
              >
                Find out More
              </motion.button>
            </motion.div>
          </motion.div>

            {/* PARTNER WITH BIGGEST BRAND */}
            <motion.section
                className="w-full py-16"
                initial="hidden"
                whileInView="visible"
                variants={fadeInUp}
                viewport={{ once: true }}
              >
                {/* Text Section */}
                <div className="max-w-3xl mx-auto px-6 text-center mb-10">
                  <h3 className="text-3xl md:text-4xl font-bold text-[#BF5717]">
                    Partnering with the Biggest Brands
                  </h3>
                  <p className="text-base md:text-lg text-gray-800 mt-4">
                    We work with some of the most
                    prominent companies on the high street, acting as trusted partners
                    to provide products tailored to their specific needs.
                  </p>
                </div>

                {/* Brands Slideshow */}
                <BrandSlideshow />
              </motion.section>

            {/* CTA SECTION */}
            <section className="py-8">
                  <div className="w-full">
                    <div
                      className="relative bg-cover bg-center"
                      style={{ backgroundImage: `url(${Dynamic})` }}
                    >
                      {/* Overlay */}
                      <div className="bg-black bg-opacity-60 py-20 text-center text-white">
                        <motion.div
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true }}
                          variants={fadeInUp}   
                        >
                          <h2 className="font-serif text-3xl md:text-4xl mb-4">
                            Dynamic. Innovative. Playful.
                          </h2>
                          <p className="max-w-2xl mx-auto mb-6 text-sm opacity-90">
                            We believe in the immense power of culture. At Yking, we've brought
                            together a team of the brightest, most talented, and passionate
                            individuals to create something exceptional.
                          </p>
            
                          <motion.a
                            href="/culture"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                          >
                            <button className="border px-4 py-2 transition-all duration-300 hover:bg-white hover:text-black">
                              Our Culture
                            </button>
                          </motion.a>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </section>
            </main>
        <Footer />
    </div>
  );
}
